import { useMemo, useState } from "react";
import { feedItems, feedTabs } from "@/mocks/gua";

export default function Feed() {
  const [active, setActive] = useState("all");
  const items = useMemo(
    () => (active === "all" ? feedItems : feedItems.filter((i) => i.tag === active)),
    [active]
  );

  return (
    <section id="feed" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-center text-center">
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
            <i className="ri-edit-2-line"></i>追瓜手记
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            吃瓜，也要吃点有营养的
          </h2>
          <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            方法论、扩散实录与观点随笔，帮你把每一次围观都变成更清晰的信息判断。
          </p>
        </div>

        <div className="mt-8 flex justify-center">
          <div className="inline-flex rounded-full border border-background-200 bg-background-50 p-1">
            {feedTabs.map((t) => (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === t.key
                    ? "bg-accent-500 font-medium text-background-50"
                    : "text-foreground-600 hover:text-accent-600"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <article
              key={item.title}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-900/80 px-2.5 py-1 text-xs font-medium text-background-100 backdrop-blur">
                  {item.cat}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-accent-700">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{item.excerpt}</p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 border-t border-background-100 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.read}
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 text-accent-700">
                    {item.spread}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}